var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLike = function SvgIconLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    fillRule: "evenodd",
    d: "M6.403 8.948a.605.605 0 0 1-.804-.001l-.338-.303C2.634 6.3.9 4.755.9 2.859.9 1.314 2.134.1 3.704.1 4.593.1 5.445.506 6 1.15A3.08 3.08 0 0 1 8.295.1C9.866.1 11.1 1.314 11.1 2.86c0 1.895-1.734 3.441-4.36 5.788z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLike;